export const getOptionalSelectionName = (optional, references = []) => {
  const candidateNames = [
    optional?.name,
    optional?.referenceName,
    optional?.referenceName1,
    optional?.productName,
    optional?.reference_name,
    optional?.reference_name_1,
  ];

  const directName = candidateNames.find((value) => typeof value === 'string' && value.trim() !== '');
  if (directName) {
    return directName;
  }

  const referenceType = optional?.referenceType ?? optional?.reference_type;
  const referenceId1 = optional?.referenceId1 ?? optional?.reference_id_1;
  const referenceId2 = optional?.referenceId2 ?? optional?.reference_id_2 ?? 0;

  const reference = references.find((item) => {
    const itemReferenceType = item?.referenceType ?? item?.reference_type;
    const itemReferenceId1 = item?.referenceId1 ?? item?.reference_id_1;
    const itemReferenceId2 = item?.referenceId2 ?? item?.reference_id_2 ?? 0;

    return itemReferenceType === referenceType
      && itemReferenceId1 === referenceId1
      && itemReferenceId2 === referenceId2;
  });

  return reference?.referenceName1 ?? reference?.referenceName ?? 'Opcional';
};

export const getOptionalSelectionsList = (item) => {
  const list = item?.optionalSelections ?? item?.optional_selections;
  return Array.isArray(list) ? list : [];
};
